import { render, staticRenderFns } from "./Clue2.vue?vue&type=template&id=00717706&lang=pug&"
import script from "./Clue2.vue?vue&type=script&lang=js&"
export * from "./Clue2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports